import React from 'react';
import { useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';
import CustomBtn from '../../generic/CustomBtn';

const NotFound = () => {
  const history = useHistory();
  const translate = useIntl();

  return (
    <div className="notfound">
      <div className="notfound__wrapper">
        <div className="notfound__number">404</div>
        <p className="notfound__title">{translate.formatMessage({ id: 'notfound.title' })}</p>
        <CustomBtn
          label={translate.formatMessage({ id: 'notfound.btn' })}
          type="click"
          handleClick={() => {
            history.goBack();
          }}
        />
      </div>
    </div>
  );
};

export default NotFound;
